<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
            <div class="text-small">The following vendors have missing emails, Please update them to proceed.</div>
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="user-profile__form">
                <section>
                    <div class="card-body p-4">
                        <form>
                            <div class="table-responsive">
                                <table class="table" [formGroup]="marketResultForm">
                                    <thead>
                                      <tr>
                                        <th scope="col"></th>
                                        <th scope="col">#</th>
                                        <th scope="col">Line Item#</th>
    
                                        <th scope="col">Vendor #</th>
                                        <th scope="col">Vendor name</th>
                                        <th scope="col">Mail Address</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let a of marketResults | keyvalue; let i = index">
                                            <tr>
                                                <th scope="row">
                                                    -
                                                </th>
                                                <th scope="row">
                                                    {{a.value?.LINE_ITEM_NUMBER}}
                                                </th>
                                                <td>{{a.value?.supplierMarketResult?.length}}</td>
                                                <td *ngFor="let x of [1,2,3]"></td>
                                            </tr>
                                            <ng-container [formArrayName]="a.key">
                                                <ng-container *ngFor="let b of getFormArrayName(a.key); let j = index">
                                                    <tr [formGroupName]="j">
                                                        <th scope="row"></th>
                                                        <td></td>
                                                        <td></td>
                                                        <td>
                                                            {{getFormArrayName(a.key).at(j).get('VENDOR_CODE').value}}
                                                        </td>
                                                        <td>
                                                            {{getFormArrayName(a.key).at(j).get('VENDOR_NAME').value}}
                                                        </td>
                                                        <td>
                                                            <div class="my-1">
                                                                <input type="email" id="vendor_code" class="form-control"
                                                                placeholder="Email" formControlName="EMAIL_ADDRESS"
                                                                [error]="getFormArrayName(a.key).at(j).get('EMAIL_ADDRESS')">
                                                                <form-feedback [formGroup]="getFormArrayName(a.key).at(j)" field="EMAIL_ADDRESS"></form-feedback>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </form>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div>
            <button type="button" class="btn btn-primary text-white" (click)="updateEmailInfo()" [disabled]="!marketResultForm.valid">Save Details</button>
        </div>
    </div>
</section>